import { Injectable, inject } from '@angular/core';
import { MasterService } from './master.service';
import { CuentasService } from './cuentas.service';
import { ArticulosService } from './articulos.service';
import { ConfiguracionesFacturacionService } from './configuraciones-facturacion.service';
import { UsersService } from './users.service';
import { SeriesService } from './series.service';
import { FamiliasArticuloService } from './familias-articulo.service';

/** Invalida en bloque las cachés de catálogos HTTP (p. ej. tras logout). */
@Injectable({ providedIn: 'root' })
export class CatalogCacheService {
  private readonly masterService = inject(MasterService);
  private readonly cuentasService = inject(CuentasService);
  private readonly articulosService = inject(ArticulosService);
  private readonly configuracionesService = inject(ConfiguracionesFacturacionService);
  private readonly usersService = inject(UsersService);
  private readonly seriesService = inject(SeriesService);
  private readonly familiasService = inject(FamiliasArticuloService);

  clearAll(): void {
    this.masterService.clearCache();
    this.cuentasService.clearCuentasBasicoCache();
    this.articulosService.clearArticulosBasicoCache();
    this.configuracionesService.clearConfiguracionesCache();
    this.usersService.clearCatalogCache();
    this.seriesService.clearSeriesCache();
    this.familiasService.clearFamiliasBasicoCache();
  }
}
